'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEBreadcrumbs = undefined;

var _map = require('ramda/src/map');

var _map2 = _interopRequireDefault(_map);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _core = require('@blueprintjs/core');

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledBreadcrumb = (0, _glamorous2.default)(_core.Breadcrumb)({}, function (_ref) {
  var isRtl = _ref.isRtl;
  return {
    transform: isRtl ? 'scaleX(-1)' : 'none'
  };
});

var StyledBreadcrumbs = _glamorous2.default.ul({}, function (_ref2) {
  var isRtl = _ref2.isRtl;
  return {
    transform: isRtl ? 'scaleX(-1)' : 'none'
  };
});

var DEBreadcrumbs = exports.DEBreadcrumbs = function DEBreadcrumbs(_ref3) {
  var items = _ref3.items,
      isRtl = _ref3.isRtl;
  return _react2.default.createElement(
    StyledBreadcrumbs,
    { className: _core.Classes.BREADCRUMBS, isRtl: isRtl },
    (0, _map2.default)(function (item) {
      return _react2.default.createElement(
        'li',
        { key: item.text },
        _react2.default.createElement(StyledBreadcrumb, _extends({ isRtl: isRtl }, item))
      );
    })(items)
  );
};

DEBreadcrumbs.propTypes = {
  items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    text: _propTypes2.default.string.isRequired,
    href: _propTypes2.default.string,
    disabled: _propTypes2.default.bool,
    target: _propTypes2.default.string,
    onClick: _propTypes2.default.func
  })),
  isRtl: _propTypes2.default.bool
};

DEBreadcrumbs.defaultProps = {
  items: []
};


//////////////////
// WEBPACK FOOTER
// ./~/oecd-visions/build/components/de-breadcrumbs/index.js
// module id = 2013
// module chunks = 0